import React,{ Suspense, LazyExoticComponent, ComponentType } from 'react';

// material-ui
import { LinearProgressProps } from '@mui/material/LinearProgress';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

interface LoaderProps extends LinearProgressProps {}

const Loadable1 = (Component: LazyExoticComponent<() => JSX.Element> | ComponentType<React.ReactNode>) => (props: LoaderProps) =>
    (
        <Suspense fallback={<Loader />}>
            <Component {...props} />
        </Suspense>
    );

    const Loadable = <P extends object = {}>(
  Component: LazyExoticComponent<ComponentType<P>> | ComponentType<P>
): ComponentType<P> => {
  const WrappedComponent = Component as ComponentType<P>;

  const LoadableComponent = (props: P) => (
    <Suspense fallback={<Loader />}>
      {React.createElement(WrappedComponent, props)}
    </Suspense>
  );

  return LoadableComponent;
};

export default Loadable;
